import cleanDeep from 'clean-deep';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useCleanSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();
  const setParams = useCallback(
    (nextParams: Record<string, unknown>) => {
      setSearchParams((current) => {
        const prevParams = {
          query: '',
          ...Object.fromEntries(current.entries()),
        };

        return cleanDeep({ ...prevParams, ...nextParams });
      });
    },
    [setSearchParams]
  );
  return {
    searchParams,
    setParams,
    paramsEntries: Object.fromEntries(searchParams.entries()),
  };
}
